module.exports = __webpack_public_path__ + "img/partner_10.2495fe49.png";